import React, { forwardRef } from "react";
import Card from "./Card";
import Section from "./Section/Section";
import SectionHeader from "./Section/SectionHeader";

const Service = forwardRef((props, ref) => {
  const content = [
    {
      src: "/assets/service01.webp",
      title: "Keyword Research",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Non, voluptatem.",
    },
    {
      src: "/assets/service02.webp",
      title: "SEO Consultancy",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Non, voluptatem.",
    },
    {
      src: "/assets/service03.webp",
      title: "Marketing",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Non, voluptatem.",
    },
  ];

  return (
    <Section id="service" ref={ref}>
      <SectionHeader
        reverse
        title={"Our Services"}
        content={"Lorem ipsum dolor sit amet, consectetur adipisicing elit."}
      />
      {content.map((item) => (
        <Card key={item.title}>
          <figure className="overflow-hidden w-full aspect-w-16 h-[180px] max-h-[180px]">
            <img className="object-cover " src={item.src} alt={item.title} />
          </figure>
          <h3 className="px-4 text-2xl font-serif text-indigo-800 font-bold">
            {item.title}
          </h3>
          <p className="px-4 line-clamp-2 text-sm text-slate-500">
            {item.content}
          </p>
          <button className="ml-4">
            <div className="flex gap-4 text-orange-600 uppercase font-bold activeGhost w-fit rounded-sm hover:gap-6 hover:transition duration-200 ease-in-out">
              more
              <svg className="stroke-orange-600 w-6 h-6" viewBox="0 0 24 25">
                <path
                  d="M14 5.22101L21 12.221M21 12.221L14 19.221M21 12.221L3 12.221"
                  stroke="current"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </button>
        </Card>
      ))}
    </Section>
  );
});

export default Service;
